import { DeprecatedIcon } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import { FEEDBACK_FACES } from 'constants/feedback-faces';
import { jsx as _jsx } from "react/jsx-runtime";

const FaceIcon = _ref => {
  let {
    rating,
    isActive,
    onClick
  } = _ref;
  const translate = useTranslate('user.feedback.feedback_form.rating');

  function handleFaceSelect() {
    onClick(rating);
  }

  const iconName = FEEDBACK_FACES[rating];
  const iconColor = isActive ? DeprecatedIcon.Color.Primary : DeprecatedIcon.Color.GreyscaleLevel4;
  return /*#__PURE__*/_jsx("button", {
    type: "button",
    className: "u-cursor-pointer",
    "data-testid": "feedback-resolved-face-icon-".concat(rating),
    onClick: handleFaceSelect,
    title: translate("rate_".concat(rating)),
    "aria-pressed": isActive,
    children: /*#__PURE__*/_jsx(DeprecatedIcon, {
      color: iconColor,
      name: iconName,
      size: DeprecatedIcon.Size.Large
    })
  });
};

export { FaceIcon };